import React from 'react';
import PropTypes from 'prop-types';

const CrossBullet = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={19} viewBox="0 0 20 19" fill="none" {...props}>
    <path
      fill={color}
      fillRule="evenodd"
      d="M10 18.333A9.167 9.167 0 1 0 10 0a9.167 9.167 0 0 0 0 18.333ZM5.574 4.74a.75.75 0 0 1 1.06 0l3.283 3.283L13.2 4.74a.75.75 0 1 1 1.06 1.061l-3.282 3.283 3.282 3.282a.75.75 0 0 1-1.06 1.061l-3.283-3.282-3.283 3.282a.75.75 0 1 1-1.06-1.06l3.282-3.283L5.574 5.8a.75.75 0 0 1 0-1.06Z"
      clipRule="evenodd"
    />
  </svg>
);

CrossBullet.propTypes = {
  color: PropTypes.string
};

export default CrossBullet;
